module.exports = __webpack_public_path__ + "img/messages-with-alert.8417fc26.svg";